import React, { useRef, useState, useEffect } from "react";
import PropTypes from "prop-types";
import { motion } from "framer-motion";
import { FiX } from "react-icons/fi";

const Avatar = ({ onClick, onClose }) => {
  const isDraggingRef = useRef(false);
  const avatarRef = useRef(null);
  const [constraints, setConstraints] = useState({
    left: -1000,
    right: 20,
    top: -1000,
    bottom: 20,
  });

  useEffect(() => {
    const updateConstraints = () => {
      if (avatarRef.current) {
        const { offsetWidth, offsetHeight } = avatarRef.current;
        setConstraints({
          left: -(window.innerWidth - offsetWidth - 20),
          right: 20,
          top: -(window.innerHeight - offsetHeight - 20),
          bottom: 20,
        });
      }
    };

    // Calculate constraints on mount and when window resizes
    updateConstraints();
    window.addEventListener("resize", updateConstraints);
    return () => window.removeEventListener("resize", updateConstraints);
  }, []);

  return (
    <motion.div
      ref={avatarRef}
      className="chat-avatar-container"
      drag
      dragConstraints={constraints}
      dragElastic={0}
      dragMomentum={false}
      onDragStart={() => {
        isDraggingRef.current = true;
      }}
      onDragEnd={() => {
        setTimeout(() => {
          isDraggingRef.current = false;
        }, 150);
      }}
      style={{
        position: "fixed",
        bottom: 20,
        right: 20,
        zIndex: 9999,
      }}
    >
      <div style={{ position: "relative" }}>
        <button
          onClick={(e) => {
            e.stopPropagation();
            if (isDraggingRef.current) {
              return;
            }
            if (onClose) {
              onClose();
            }
          }}
          style={{
            position: "absolute",
            top: "-8px",
            right: "-5px",
            background: "#ff4d50d2",
            color: "white",
            borderRadius: "50%",
            width: "18px",
            height: "18px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            border: "none",
            cursor: "pointer",
            zIndex: 10,
            padding: 0,
          }}
          title="Hide AI Agent"
        >
          <FiX size={12} />
        </button>
        <button
          onClick={(e) => {
            if (isDraggingRef.current) {
              e.preventDefault();
              e.stopPropagation();
              return;
            }
            onClick(e);
          }}
          className="chat-avatar-btn"
          title="Open AI Agent"
        >
          <img
            src="/chat-bot.jpg"
            alt="AI Chat Avatar"
            className="chat-avatar-img"
            draggable={false}
            onError={(e) => {
              e.target.style.display = "none";
            }}
          />
        </button>
      </div>
    </motion.div>
  );
};

Avatar.propTypes = {
  onClick: PropTypes.func.isRequired,
  onClose: PropTypes.func,
  ChatUserId: PropTypes.any,
  isChat: PropTypes.any,
  ChatBusinessId: PropTypes.any,
};

export default Avatar;
